import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CopyableIdProps {
  value: string;
  label?: string;
}

export function CopyableId({ value, label = "Copia" }: CopyableIdProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <code className="rounded bg-muted px-2 py-0.5 font-mono text-xs break-all">
        {value}
      </code>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 gap-1 px-2 text-xs"
        onClick={handleCopy}
        aria-label={label}
      >
        {copied ? (
          <>
            <Check className="h-3.5 w-3.5" />
            <span>Copiato!</span>
          </>
        ) : (
          <>
            <Copy className={cn("h-3.5 w-3.5")} />
            <span>{label}</span>
          </>
        )}
      </Button>
    </div>
  );
}
